import { fieldLabel } from "../lib/palette";
import type { FieldKind } from "../types";
import { FieldGlyph, IcoClose, IcoPlus } from "../ui/icons";

export function PlaceMode({
  kind,
  color,
  onCancel,
  onAddPlain,
}: {
  kind: FieldKind;
  color: string;
  onCancel: () => void;
  onAddPlain: () => void;
}) {
  return (
    <div className="sg-place">
      <em className="sg-place__glyph" style={{ color }}>
        <FieldGlyph kind={kind} />
      </em>
      <h3>Dessinez un champ sur le document</h3>
      <p>{fieldLabel(kind)}</p>
      <button type="button" className="sg-btn ghost" onClick={onCancel}>
        <IcoClose />
        Annuler
      </button>
      <span className="sg-place__or">ou</span>
      <button type="button" className="sg-btn" onClick={onAddPlain}>
        <IcoPlus />
        Ajouter un champ sans le dessiner
      </button>
    </div>
  );
}
